import Select from '../Select';

const OPTIONS = {
  binary: {
    1: __('Yes'),
    0: __('No'),
  },
  boolean: [
    { name: __('Yes'), value: true },
    { name: __('No'), value: false },
  ],
};

const SelectBoolean = ({ valueType = OPTION_TYPES.binary, ...otherProps }) => (
  <Select options={OPTIONS[valueType]} isClearable {...otherProps} />
);

export const OPTION_TYPES = {
  binary: 'binary',
  boolean: 'boolean',
};
export default SelectBoolean;
